import React, { useEffect, useState } from 'react';
import BaseHome from '../Home/BaseHome';
import { useParams } from 'react-router-dom';
import { getBlogDetails } from '../../api/worldOfEsports.api';
import { url } from '../../config/url';
import ListLoader from '../Common/ListLoader';

const EsportsDetailPage = () => {
  const { id } = useParams(); // Get the ID from the URL
  const [blogDetail, setBlogDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogDetail();
  }, []);

  const fetchBlogDetail = async () => {
    setLoading(true);
    try {
      const res = await getBlogDetails(id); // Directly call with id
      if (res?.success && res?.data) {
        setBlogDetail(res.data); // Directly assign the data object
      }
    } catch (error) {
      console.error("Error fetching blog details:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseHome isFooter={false} title="esports news" MaxFullPageScroll={true}>
      {loading ? (
        <div className='w-100 d-flex justify-content-center'><ListLoader /></div>
      ) : blogDetail ? ( // Check if blogDetail is truthy
        <>
          <img src={url?.IMAGE_URL + blogDetail?.img?.default} className="tournament-image" alt={blogDetail?.title} />
          <h5 style={{ color: "#fff", fontSize: "16px" }} className='text-custom-color mt-3'>{blogDetail?.title}</h5>
          <div className="page-description">
            <p className="text-custom-color" style={{ color: "#acacb4", fontSize: "12px" }} dangerouslySetInnerHTML={{ __html: blogDetail?.description }} />
          </div>
        </>
      ) : (
        <div className='w-100 d-flex justify-content-center'>
          <span className="text-center">No data found</span>
        </div>
      )}
    </BaseHome>
  );
};

export default EsportsDetailPage;
